// Shared predicates for the draft / AI-suggestion pipeline.
// Imported by AppContent's inbox filter, useDraftsQueue, DraftsReview's
// prefetch effect, and ThoughtDetail's suggestion guard — keep all
// derivative checks in this file.

// A thought is a "draft" until it has BOTH at least one tag AND an
// importance value (1-5). Both together are the minimum classification we
// ask for before a thought leaves the inbox.
//
// The slider's "Not set" sentinel is null. Older rows can land here as 0
// because the service used to coerce null/undefined → 0 on read; treat 0
// as unset so historical data doesn't auto-classify those thoughts.
export const isDraftThought = (t) => {
  const hasTag = Array.isArray(t.tags) && t.tags.length > 0;
  const hasImportance = typeof t.importance === 'number' && t.importance > 0;
  return !(hasTag && hasImportance);
};

// AI suggestion bounds — too short and the model has nothing to work with;
// too long and we waste context.
export const MIN_SUGGESTION_WORDS = 3;
export const MAX_SUGGESTION_WORDS = 50;

const wordCount = (text) =>
  !text ? 0 : text.trim().split(/\s+/).filter(Boolean).length;

export const isPrefetchableText = (text) => {
  const n = wordCount(text);
  return n >= MIN_SUGGESTION_WORDS && n <= MAX_SUGGESTION_WORDS;
};
